import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";

import { routes } from "./app.routes";
import { initializeApp, provideFirebaseApp, getApp } from "@angular/fire/app";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { browserLocalPersistence, setPersistence } from "firebase/auth";
import {
	initializeFirestore,
	provideFirestore,
	persistentLocalCache,
	persistentMultipleTabManager,
} from "@angular/fire/firestore";
import { getFunctions, provideFunctions } from "@angular/fire/functions";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideAnimations(),
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideAuth(() => {
			const auth = getAuth();
			// Explicitly set persistence to LOCAL (keeps users logged in across browser restarts)
			setPersistence(auth, browserLocalPersistence).catch((error) => {
				console.error("Failed to set auth persistence:", error);
			});
			return auth;
		}),
		provideFirestore(() => {
			const app = getApp();
			const firestore = initializeFirestore(app, {
				localCache: persistentLocalCache({
					tabManager: persistentMultipleTabManager(),
				}),
			});
			return firestore;
		}),
		provideFunctions(() => {
			const functions = getFunctions(
				undefined,
				(environment as any).region || "europe-west1",
			);
			return functions;
		}),
	],
};
